<nav
  class="sidebar-menu"
  [class.sidebar-menu--mini]="isSidebarMini"
  [class.sidebar-menu--animated]="transitionEnabled"
  [class.sidebar-menu--animate-children]="animateChildren"
>
  <div class="sidebar-menu__brand">
    <span class="sidebar-menu__brand-text" (click)="goToHome()">
      <i class="fas fa-dollar-sign" aria-hidden="true"></i>
      <span>ogivendas</span>
    </span>
  </div>

  <div
    class="sidebar-menu__search"
    *ngIf="settings.searchable"
    (click)="onSearchAreaClick()"
  >
    <sgt-input-search
      #searchInput
      [placeholder]="settings.placeholder"
      [focusable]="!isSidebarMini"
      (searched)="onSearchInput($event)"
    ></sgt-input-search>
  </div>

  <ul
    class="sidebar-menu__list"
    [class.sidebar-menu__list--mini]="isSidebarMini"
  >
    <li
      *ngFor="let item of visibleItems; trackBy: trackByItem"
      class="sidebar-menu__item"
      [class.sidebar-menu__item--group]="hasChildren(item)"
      [class.sidebar-menu__item--active]="isAtivo(item)"
    >
      <a
        *ngIf="hasChildren(item)"
        class="sidebar-menu__link"
        [title]="item.label"
        (click)="onGroupClick(item)"
        (mouseenter)="onGroupEnter(item, $event)"
        (mouseleave)="onGroupLeave()"
      >
        <i class="sidebar-menu__icon" *ngIf="item.icon" [ngClass]="item.icon"></i>
        <span class="sidebar-menu__label">{{ item.label }}</span>
        <i
          class="sidebar-menu__arrow fas fa-angle-right"
          [class.sidebar-menu__arrow--expanded]="isExpanded(item)"
        ></i>
      </a>

      <a
        *ngIf="!hasChildren(item)"
        class="sidebar-menu__link"
        [title]="item.label"
        [routerLink]="item.path"
        [class.sidebar-menu__link--active]="isAtivo(item)"
        (click)="onNavigate()"
      >
        <i class="sidebar-menu__icon" *ngIf="item.icon" [ngClass]="item.icon"></i>
        <span class="sidebar-menu__label">{{ item.label }}</span>
      </a>

      <div
        *ngIf="hasChildren(item)"
        class="sidebar-menu__collapse"
        [class.sidebar-menu__collapse--open]="isExpanded(item)"
      >
        <ul class="sidebar-menu__group-items">
          <li
            *ngFor="let child of visibleChildren(item); trackBy: trackByItem"
            class="sidebar-menu__item"
          >
            <a
              class="sidebar-menu__link sidebar-menu__link--child"
              [title]="child.label"
              [routerLink]="child.path"
              [class.sidebar-menu__link--active]="isAtivo(child)"
              (click)="onNavigate()"
            >
              <i class="sidebar-menu__icon" *ngIf="child.icon" [ngClass]="child.icon"></i>
              <span class="sidebar-menu__label">{{ child.label }}</span>
            </a>
          </li>
        </ul>
      </div>
    </li>
  </ul>

  <div
    class="sidebar-menu-submenu"
    *ngIf="submenuItem"
    [ngStyle]="submenuStyle"
    (mouseenter)="onSubmenuEnter()"
    (mouseleave)="onSubmenuLeave()"
  >
    <div class="sidebar-menu-submenu__header">
      <i
        class="sidebar-menu-submenu__header-icon"
        *ngIf="submenuItem.icon"
        [ngClass]="submenuItem.icon"
      ></i>
      <span class="sidebar-menu-submenu__title">{{ submenuItem.label }}</span>
    </div>

    <div class="sidebar-menu-submenu__items">
      <a
        *ngFor="let child of submenuItem.children"
        class="sidebar-menu-submenu__item"
        [title]="child.label"
        [routerLink]="child.path"
        [class.sidebar-menu-submenu__item--active]="isAtivo(child)"
        (click)="onSubmenuItemClick()"
      >
        <i class="sidebar-menu-submenu__bullet fas fa-circle"></i>
        <span>{{ child.label }}</span>
      </a>
    </div>
  </div>
</nav>
